export default function ComoFuncionaSection() {
  const passos = [
    {
      numero: '01',
      icone: 'ri-chat-3-line',
      titulo: 'Conversa inicial',
      descricao: 'Você conversa com a Bravia e escolhe o projeto que faz sentido para o seu perfil e objetivo.',
    },
    {
      numero: '02',
      icone: 'ri-file-text-line',
      titulo: 'Assinatura',
      descricao: 'Assina o contrato e entra no grupo de investidores do projeto selecionado.',
    },
    {
      numero: '03',
      icone: 'ri-eye-line',
      titulo: 'Acompanhamento',
      descricao: 'Acompanha a obra por meio de atualizações regulares, relatórios e fotos do progresso.',
    },
    {
      numero: '04',
      icone: 'ri-home-smile-line',
      titulo: 'Entrega e resultado',
      descricao: 'Recebe a entrega conforme o plano do projeto e os resultados acordados.',
    },
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-4">Como funciona</h2>
          <p className="text-xl text-gray-600">Processo simples e transparente em 4 passos</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {passos.map((passo) => (
            <div
              key={passo.numero}
              className="relative bg-white border border-gray-100 rounded-2xl p-10 hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="absolute top-8 left-8 text-8xl font-bold text-gold-500/30 leading-none">
                {passo.numero}
              </div>
              <div className="relative z-10">
                <div className="w-16 h-16 mx-auto mb-6 rounded-full border-2 border-black flex items-center justify-center group-hover:bg-black group-hover:text-white transition-all">
                  <i className={`${passo.icone} text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-black text-center mb-4">{passo.titulo}</h3>
                <p className="text-gray-600 text-center leading-relaxed">{passo.descricao}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
